<template>
	<div class="section">
		<div class="container">
			<h1>Results of ACC calculation and further information</h1>
			<br />
			<p>
				The results of the AWG carbon calculator represent the set of assumptions described in the Calculation Methodology Document.
				If a user needs calculations representing a unique set of assumptions, specific aircraft serial numbers, engine models or interior configurations,
				please contact the relevant aircraft OEM representative to obtain customized carbon emissions data.
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>
